module.exports = __webpack_public_path__ + "img/logo.ae5f863d.png";